module.exports = __webpack_public_path__ + "static/media/our-partner-third.4be50b89.svg";